// components/ContactList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ContactList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/contacts`);
      
      if (response.data.success) {
        setContacts(response.data.data);
      }
    } catch (err) {
      setError('Failed to fetch contacts');
      console.error('Error fetching contacts:', err);
    } finally {
      setLoading(false);
    }
  };

  const deleteContact = async (id) => {
    if (window.confirm('Are you sure you want to delete this contact?')) {
      try {
        await axios.delete(`${API_BASE_URL}/api/contacts/${id}`);
        fetchContacts(); // Refresh the list
        alert('Contact deleted successfully!');
      } catch (err) {
        console.error('Error deleting contact:', err);
        alert('Failed to delete contact');
      }
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) return <div className="text-center py-8">Loading contacts...</div>;
  if (error) return <div className="alert alert-error">Error: {error}</div>;

  return (
    <div className="contact-list p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Contact Messages ({contacts.length})</h2>
        <button 
          onClick={fetchContacts}
          className="btn btn-outline btn-sm"
        >
          Refresh
        </button>
      </div>
      
      {contacts.length === 0 ? (
        <div className="text-center py-8 bg-base-100 rounded-lg">
          <p className="text-lg">No contact messages found.</p>
        </div>
      ) : (
        <div className="overflow-x-auto bg-base-100 rounded-lg shadow">
          <table className="table table-zebra w-full">
            <thead>
              <tr>
                <th>Name</th>
                <th>Mobile</th>
                <th>Message</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map(contact => (
                <tr key={contact.id}>
                  <td>
                    <div className="font-semibold">{contact.name}</div>
                  </td>
                  <td>
                    <div className="font-mono">{contact.mobile}</div>
                  </td>
                  <td>
                    <div className="max-w-xs truncate" title={contact.message}>
                      {contact.message}
                    </div>
                  </td>
                  <td>
                    <div className="text-sm text-base-content/70">
                      {formatDate(contact.created_at)}
                    </div>
                  </td>
                  <td>
                    <button 
                      onClick={() => deleteContact(contact.id)}
                      className="btn btn-error btn-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ContactList;